<template>
  <section class="top-cover">
    <a href="/items" class="top-cover__link">
      <div class="top-cover-image">
        <div class="top-cover-image__wrap">
          <img :src="selectedImage" alt="top-cover" />
        </div>
        <span class="top-cover-image__text">{{ catchCopy }}</span>
      </div>
      <div class="top-cover-title">
        <span class="top-cover-title__text">{{ catchCopy }}</span>
      </div>
      <div class="top-cover-search">
        <span class="top-cover-search__text">ギフト一覧から探す</span>
        <ArrowForwardPrimary class="top-cover-search__icon" />
      </div>
    </a>
  </section>
</template>

<script>
// TODO: S3 に配置して勝手にランダムに表示できるようにしたい
import topCoverFirst from '../../../../../../images/top_covers/May_01.png'
import topCoverSecond from '../../../../../../images/top_covers/May_02.png'
import ArrowForwardPrimary from '../../../atoms/svg_icons/ArrowForwardPrimary'
export default {
  components: { ArrowForwardPrimary },
  data() {
    return {
      backgroundImages: [topCoverFirst, topCoverSecond],
      selectedImage: '',
      catchCopy: 'そのキモチ、贈ってみよう。'
    }
  },
  mounted() {
    const idx = Math.floor(Math.random() * this.backgroundImages.length)
    this.selectedImage = this.backgroundImages[idx]
  }
}
</script>
<style lang="scss" scoped>
.top-cover {
  margin: 24px auto;
  width: 100%;
  max-width: $max-contents-width;
  background-color: $white;

  @media all and (max-width: $max-contents-width - 1) {
    margin: 0 auto 24px;
  }

  @media all and (max-width: $base-contents-width - 1) {
    margin: 0 auto 16px;
  }

  &__link {
    @extend %hover-common;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    @media all and (max-width: $base-contents-width - 1) {
      flex-direction: column;
    }
  }

  &-image {
    width: 100%;
    font-size: 0;
    position: relative;

    // NOTE: リロード時にimgの読み込み前に要素がガタつくのを防ぐ実装
    &__wrap {
      width: 100%;
      position: relative;

      &:before {
        content: '';
        display: block;
        padding-top: 56.25%;
        background-color: $gray-3;
      }

      img {
        width: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }

    &__text {
      padding: 8px 16px;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      font-family: YuGothic, arial, 'Noto Sans JP', sans-serif;
      font-weight: bold;
      font-size: 1.2rem;
      line-height: 1.6;
      letter-spacing: 0.1em;
      color: $black;
      background-color: $white;
      display: none;

      @media all and (max-width: $base-contents-width - 1) {
        display: block;
      }

      @media all and (max-width: 440px) {
        font-size: 1rem;
      }
    }
  }

  &-title {
    margin: 0 auto;
    padding: 24px;
    min-width: 280px;
    text-align: right;

    &__text {
      font-family: YuGothic, arial, 'Noto Sans JP', sans-serif;
      font-weight: bold;
      font-size: 1.8rem;
      line-height: 2;
      letter-spacing: 0.15em;
      color: $black;
    }

    @media all and (max-width: $base-contents-width - 1) {
      display: none;
    }
  }

  &-search {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 24px;
    right: 24px;

    @media all and (max-width: $base-contents-width - 1) {
      margin: 0 auto;
      padding: 16px 0;
      position: unset;
    }

    &__text {
      font-weight: bold;
      font-size: 1.4rem;
      line-height: 1.6;
      color: $primary;
    }

    &__icon {
      width: 24px;
      height: 24px;

      @media all and (max-width: $base-contents-width - 1) {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
